import React, { useEffect, useContext, useState } from "react";
//axios and base url
import axios from "axios";
import Select from "react-select";

import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  customStyle,
  getCookie,
  tableLoading,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { ToastError } from "../../../../../functions/ToastShow";
import { useCustomHooks } from "../../../../../functions/Hooks";

const offlineTables = [
  {
    id: 1,
    name: "Branch",
    value: "branches",
  },
  {
    id: 2,
    name: "Tables",
    value: "tables",
  },
  {
    id: 3,
    name: "Floor",
    value: "floors",
  },
];

const initialState = {
  branches: 0,
  tables: 0,
  floors: 0,
};

const OfflineTableSync = () => {

  const { t } = useTranslation();
  const { branchForSearch } = useContext(RestaurantContext);
  const { getDynamicOfflineApiUrl } = useCustomHooks();
  
  let { loading, setLoading } = useContext(SettingsContext);
  //offline sync
  const [offlineSync, setOfflineSync] = useState(initialState);
  const [selectedBranch, setSelectedBranch] = useState(null);


  // const getOfflineSync = async () => {
  //   const url = BASE_URL + "/settings/sync-live-database-tables";
  //   setLoading(true);
  //   try {
  //     const res = await axios.get(url, {
  //       headers: { Authorization: `Bearer ${getCookie()}` },
  //     });
  //     setLoading(false);
  //   } catch (err) {
  //     setLoading(false);
  //     toast.error(`${_t(t("Please try again"))}`, {
  //       position: "bottom-center",
  //       autoClose: 10000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       className: "text-center toast-notification",
  //     });
  //   }
  // }
  // useEffect(()=>{
  //   getOfflineSync();
  // },[])

  const handleChange = (e) => {
    setOfflineSync({ ...offlineSync, [e.target.name]: offlineSync[e.target.name] ? 0 : 1 });
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    if (!selectedBranch) {
      ToastError({ title: t("Please select branch") });
      return;
    }

    if (selectedBranch?.offline_enable == 0) {
      ToastError({ title: t("Offline mode is not enabled for this branch") });
      return;
    }

    if (offlineSync) {
      let formData = {
        tables: offlineSync
      };
      const url = BASE_URL + "/settings/sync-live-database-tables";
      setLoading(true);
      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          if (res) {
            toast.success(
              <span style={{ whiteSpace: "pre-line" }}>{res.data.message}</span>,
              {
                position: "bottom-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              }
            );
          }
          submitOfflineData(res?.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          ToastError({ title: t("Please try again") });
        });
    } else {
      ToastError({ title: t("Please fill required fields") });
    }
  };

  const submitOfflineData = async (payload) => {
    const url = getDynamicOfflineApiUrl("/settings/create-update-database-tables");

    const res = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
  }

  return (
    <>
      <Helmet>
        <title>{_t(t("Offline Table Sync"))}</title>
      </Helmet>
      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${loading && "loading"}`}></div>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    <div className="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-8 col-lg-9 t-mb-15 mb-md-0 ">
                          <ul className="t-list mb-3 fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Offline Table Sync"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-4 col-lg-3">
                          <Select
                            options={branchForSearch || []}
                            getOptionLabel={option => option.name}
                            getOptionValue={option => option.id}
                            value={selectedBranch || ""}
                            classNamePrefix="select table-text"
                            onChange={(branch) => setSelectedBranch(branch)}
                            placeholder={t("Please select branch") + ".."}
                            styles={customStyle}
                            required
                          />
                        </div>
                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 sm-text my-2"
                          style={{ width: "97%" }}
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="mt-3"></div>
                          {
                            offlineTables && offlineTables.map((item) => {
                              return (
                                <div className="form-group">
                                  <div className="mb-2 table-text font-weight-md">
                                    <input
                                      type="checkbox"
                                      className="form-check-input pointer-cursor"
                                      id={item.name}
                                      name={item.value}
                                      value={item.value}
                                      onChange={(e) => handleChange(e)}
                                      checked={parseInt(offlineSync[item.value]) === 1}
                                    />
                                    <label htmlFor={item.name} className="control-label ml-2">
                                      {_t(t(item.name))}
                                    </label>
                                  </div>
                                </div>
                              )
                            })
                          }

                          <div className="form-group mt-3 pb-3">
                            <div className="mr-4 float-right">
                              <button
                                disabled={loading}
                                className="btn btn-primary px-5 rounded"
                                type="submit"
                              >
                                {_t(t("Save"))}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default OfflineTableSync;
